import React from "react";
import { Layout, Menu, Button, Row, Col, Drawer } from "antd";
import {
  LogoutOutlined,
  MenuUnfoldOutlined,
  RocketOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import Facturacion from "./Facturacion";
import { VentasHoy } from "./VentasToday";
import { useState } from "react";
import { Typography } from "@material-ui/core";
import "firebase/auth";
import { useFirebaseApp } from "reactfire";
import Logo from "../../Assets/img/LOGO-BABY-PANDA.svg";
import { LayoutProducto } from "./LayoutProducto";
import { MassUpload } from "./MassUpload";

const { Header, Sider } = Layout;

export default function RootLayout() {
  const [contentab, setcontentab] = useState(2);
  let fb = useFirebaseApp();
  let History = useHistory();
  const [visibledrawer, setvisibledrawer] = useState(false);

  const HandleChange = (item) => {
    console.log(item.key);
    if (parseInt(item.key) === 4) {
      Logout();
    } else {
      // console.log(item.key);
      setcontentab(parseInt(item.key));
    }
  };

  const Logout = () => {
    fb.auth()
      .signOut()
      .then(() => {
        History.push("/login");
      })
      .catch((error) => {
        // An error happened.
      });
  };

  function onClosedrawer() {
    setvisibledrawer(false);
  }

  function onShowdrawer() {
    setvisibledrawer(true);
  }

  const titles = [
    "nothing",
    "Reporte de ventas",
    "Creación de Productos",
    "Reporte Diario",
    "nothing",
    "Cargue masivo"
  ];

  const renderSwitch = () => {
    switch(contentab) {
      case 1:
        return <Facturacion />;
      
      case 2:
        return <LayoutProducto />
      
      case 3:
        return <VentasHoy />

      case 5:
        return <MassUpload />
      
      default:
        return 'No se encontró componente'
    }
  }

  return (
    <Layout className="dashboard-shell">
      <Sider
        className="dashboard-sider"
        width={248}
      >
        <div className="dashboard-brand">
          <img src={Logo} alt="Seze" className="logo-img-dash" />
        </div>
        <Menu
          className="dashboard-menu"
          onSelect={(item) => HandleChange(item)}
          mode="inline"
          defaultSelectedKeys={["2"]}
        >
          <Menu.Item key="2" icon={<RocketOutlined />}>
            CREAR PRODUCTO
          </Menu.Item>

          <Menu.Item key="4" icon={<LogoutOutlined />}>
            CERRAR SESIÓN
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className="dashboard-main">
        <Header className="dashboard-header">
          <Row align="middle" justify="space-between" wrap={false}>
            <Col flex="40px">
              <Button
                className="dashboard-menu-button"
                onClick={() => onShowdrawer()}
                icon={<MenuUnfoldOutlined />}
              />
            </Col>

            <Col flex="auto">
              <Typography className="dashboard-title">
                {titles[contentab]}
              </Typography>
            </Col>
          </Row>

          <Drawer
            className="dashboard-drawer"
            placement="left"
            closable={false}
            onClose={() => onClosedrawer()}
            open={visibledrawer}
          >
            <div className="dashboard-brand dashboard-brand-drawer">
              <img src={Logo} alt="Seze" className="logo-img-dash" />
            </div>
            <Menu
              className="dashboard-menu"
              onSelect={(item) => HandleChange(item)}
              mode="inline"
              defaultSelectedKeys={["2"]}
            >
              <Menu.Item key="2" icon={<RocketOutlined />}>
                CREAR PRODUCTO
              </Menu.Item>

              <Menu.Item key="4" icon={<LogoutOutlined />}>
                CERRAR SESIÓN
              </Menu.Item>
            </Menu>
          </Drawer>
        </Header>

        { renderSwitch() }
      </Layout>
    </Layout>
  );
}
